<app-page-shell>
    <p-toast position="top-center"></p-toast>

    <app-page-hero
        eyebrow="Payables"
        title="AP Matching"
        subtitle="Track vendor bill match status, pending receipt evidence, and tolerance exceptions before posting or payment.">
        <div actions>
            <p-button label="Policies" icon="pi pi-sliders-h" severity="secondary" [outlined]="true" routerLink="/accounts/enterprise/payables/matching-policies"></p-button>
            <p-button label="Refresh" icon="pi pi-refresh" (click)="load()" [loading]="loading"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <app-page-data-panel title="Matching Exceptions" subtitle="Bills that need correction, receipt evidence, or an approved tolerance override." [resultText]="exceptions.length + ' open'">
        <div actions>
            <span class="inline-field">
                <i class="pi pi-hashtag"></i>
                <input pInputText [(ngModel)]="sourceReferenceNumber" placeholder="Optional PO/reference for re-evaluation">
            </span>
        </div>

        <p-table [value]="exceptions" [loading]="loading" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Bill</th>
                    <th>Vendor</th>
                    <th>Status</th>
                    <th>Policy</th>
                    <th>Source</th>
                    <th class="numeric">Variance</th>
                    <th>Reason</th>
                    <th class="actions">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{ row.billNumber || row.billId }}</td>
                    <td>{{ row.vendorId || '-' }}</td>
                    <td><p-tag [value]="row.evaluationStatus || 'PENDING_MATCH'" [severity]="statusSeverity(row.evaluationStatus)"></p-tag></td>
                    <td>{{ row.matchType || 'NOT_REQUIRED' }}</td>
                    <td>{{ row.sourceReferenceNumber || row.sourceReferenceId || '-' }}</td>
                    <td class="numeric">{{ money(row.varianceAmount) }}</td>
                    <td>{{ row.exceptionReason || '-' }}</td>
                    <td class="actions">
                        <p-button icon="pi pi-check-square" label="Evaluate" size="small" [outlined]="true" (click)="evaluate(row)"></p-button>
                        <p-button icon="pi pi-external-link" label="Open" size="small" severity="secondary" [outlined]="true" (click)="openBill(row)"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="8">No AP matching exceptions are open.</td></tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
